import { useState } from 'react'
import MobiHeader from './MobiHeader.jsx'
import { CurrentDream, WaveCanvas, FeedbackBar } from './CurrentDream.jsx'
import Measurements from './Measurements.jsx'
import DreamMapPanel from './DreamMapPanel.jsx'
import ContextStrip from './ContextStrip.jsx'
import DetailDrawer from './DetailDrawer.jsx'
import { useDreamSocket, useDreamMorph, useInstrumentData } from './hooks.js'

export default function DreamMachine() {
  const { dream, prevDream, status, learning, memories, connected } = useDreamSocket()
  const { displaySequence, displayAscii } = useDreamMorph(dream, prevDream)
  const { dreamMap, generators, evolution, evoPopulation } = useInstrumentData(dream)
  const [mapSelected, setMapSelected] = useState(null)
  const [detail, setDetail] = useState(null)

  return (
    <div className="dream-machine-section mobi-observatory">
      <MobiHeader status={status} connected={connected} learning={learning} />

      <div className="mobi-frame">
        <div className="mobi-primary">
          <div className="mobi-col-dream">
            <CurrentDream
              dream={dream}
              asciiPattern={displayAscii}
              onOpenDetail={setDetail}
            />
            <WaveCanvas sequence={displaySequence || dream?.sequence} />
            <FeedbackBar dreamId={dream?.id} />
            <Measurements dream={dream} onOpenDetail={setDetail} />
          </div>

          <div className="mobi-col-map">
            <DreamMapPanel
              map={dreamMap}
              selected={mapSelected}
              onSelect={setMapSelected}
              onOpenDetail={setDetail}
            />
          </div>
        </div>

        <ContextStrip
          dream={dream}
          memories={memories}
          generators={generators}
          evolution={evolution}
          evoPopulation={evoPopulation}
          onOpenDetail={setDetail}
        />

        {detail && (
          <DetailDrawer detail={detail} onClose={() => setDetail(null)} />
        )}
      </div>
    </div>
  )
}
